<div class="left-sec">{{icon}}</div>
<div class="right-sec">{{text}}</div>